import { FC, useContext } from "react";
import { RootState } from "src/store/rootReducer";
import { selectGetStatus } from "src/modules/spItems/selectors";
import { useAppSelector } from "src/hooks/redux";
import { questionsRegistry } from "src/api/config/notifications.config";
import Loading from "src/components/Loading";
import { useFormContext } from "react-hook-form";
import { TestRegistryContext } from "../store/testRegistryContext";
import { DragDropContext, Draggable, Droppable, DropResult } from "react-beautiful-dnd";

interface IProps {
  questions: any;
  editQuestion: (id: number) => void;
  onDragEnd: (result: DropResult) => void;
}

export const QuestionsList: FC<IProps> = ({ questions, editQuestion, onDragEnd }) => {
  const status = useAppSelector((state: RootState) => selectGetStatus(state, questionsRegistry));
  const { state } = useContext(TestRegistryContext);
  const { setValue } = useFormContext();

  const editingQuestion = (id: number) => {
    editQuestion(id);
    setValue("MinCorrectAnswersCount", state.minCorrectAnswersCount);
  };

  return status === "LOADING" ? (
    <div>
      <Loading />
    </div>
  ) : (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="questions">
        {provided => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {questions?.map((question: any, index: number) => (
              <Draggable draggableId={question.ID.toString()} index={index} key={question.ID}>
                {provided => (
                  <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className="p-5 bg-[#F3F4F6] mb-[10px] rounded-md flex ">
                    <span className="mr-5">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 4V20M17 20L13 16M17 20L21 16M7 20V4M7 4L3 8M7 4L11 8" stroke="#637381" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>

                    <div>
                      <div className="text-black flex items-center gap-[10px]">
                        Вопрос {index + 1} | {question.Title}
                      </div>
                      <button
                        className="text-[#012169]"
                        onClick={() => {
                          editingQuestion(question.ID);
                        }}
                      >
                        Редактировать
                      </button>
                    </div>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
